import { useParams } from "react-router";
import LoadingPlaceholder from "../components/loadingPlaceholder";
import { useFetch } from "../hooks";
import { Markup } from "react-render-markup";
import FetchError from "../components/fetchError";

function Page() {
  const { slug } = useParams();
  const {
    response: markup,
    loading,
    error,
    retry,
  } = useFetch(`store/pages/${slug}/`, { cache: true, keepPrevious: true });

  if (error)
    return (
      <FetchError message="Nie udało się wczytać strony." onRetry={retry} />
    );

  if (loading && !markup) {
    return <LoadingPlaceholder />;
  }

  return (
    <main className="content-page" aria-busy={loading}>
      <article className="content-page__paper">
        <Markup markup={markup.body} />
      </article>
    </main>
  );
}

export default Page;
